export { default } from "./VideoCategoryCollection";
